var _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSpsLogoSmall = function SvgSpsLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.201,
    y: 38.933,
    width: 108.134,
    height: 108.134,
    rx: 19.5,
    stroke: "#E5E4FF",
    strokeOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.288,
    y: 28.02,
    width: 129.961,
    height: 129.961,
    rx: 19.5,
    stroke: "#E5E4FF",
    strokeOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.769,
    y: 16.5,
    width: 153,
    height: 153,
    rx: 19.5,
    stroke: "#E5E4FF",
    strokeOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spsLogoSmall_svg__filter0_ddddii_9227_452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.615,
    y: 49.346,
    width: 87.307,
    height: 87.307,
    rx: 20,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.924 69.609v8.302c0 .303-.182.606-.424.727L73.26 95.363v-9.756c0-.364.182-.667.486-.849l28.784-15.876c.606-.364 1.394.06 1.394.727z",
    fill: "url(#spsLogoSmall_svg__paint0_linear_9227_452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.259 96.333l-16.302-10.18s-.787-.425-.848-.91c0-.485.424-.848.424-.848s-.484.303-.787.424c-.303.182-.425.424-.425.424-.06.121-.06.243-.06.364v10.968c0 .303.181.606.424.727l8.18 5.091c.304.182.667.182 1.031 0l8.363-4.606c.545-.303.545-1.09 0-1.454z",
    fill: "#F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.35 116.391v-8.302c0-.303.182-.606.425-.727l30.239-16.725v9.756a.968.968 0 01-.485.849l-28.785 15.877c-.606.363-1.393-.061-1.393-.728z",
    fill: "url(#spsLogoSmall_svg__paint1_linear_9227_452)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.015 89.667l16.302 10.241s.787.424.848.909c0 .485-.424.849-.424.849s.485-.303.788-.425c.303-.181.424-.424.424-.424.06-.121.06-.242.06-.363V89.485c0-.303-.181-.606-.424-.727l-8.181-5.09c-.303-.182-.666-.182-1.03 0l-8.302 4.544c-.485.243-.545 1.091-.06 1.455z",
    fill: "#F05"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spsLogoSmall_svg__paint0_linear_9227_452",
    x1: 101.577,
    y1: 74.542,
    x2: 67.116,
    y2: 93.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#E0004B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DF024B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#DB0B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#D5194C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC2B4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spsLogoSmall_svg__paint1_linear_9227_452",
    x1: 84.719,
    y1: 111.458,
    x2: 119.18,
    y2: 92.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#E0004B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DF024B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#DB0B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#D5194C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC2B4D"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spsLogoSmall_svg__filter0_ddddii_9227_452",
    x: 0.615,
    y: 0.346,
    width: 185.307,
    height: 185.307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.341177 0 0 0 0 0.459765 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9227_452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14,
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.445833 0 0 0 0 0.56775 0 0 0 0 1 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9227_452",
    result: "effect2_dropShadow_9227_452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14,
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.447059 0 0 0 0 0.568627 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_9227_452",
    result: "effect3_dropShadow_9227_452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647059 0 0 0 0 0.647059 0 0 0 0 0.647059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_9227_452",
    result: "effect4_dropShadow_9227_452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_9227_452",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647059 0 0 0 0 0.647059 0 0 0 0 0.647059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect5_innerShadow_9227_452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect5_innerShadow_9227_452",
    result: "effect6_innerShadow_9227_452"
  })))));
};
export default SvgSpsLogoSmall;